import { ApiBase } from './ApiBase';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ConvertedDuplicatedDateInstances,
  DataInstance,
  DuplicateDataInstanceRequest,
  GetParentResponse,
  Resource,
} from '@apis/cas/generated';

@Injectable({ providedIn: 'root' })
export class DataInstanceEndpoints extends ApiBase {
  public getAllDataInstancesByStructTypeId(structTypeId: string): Observable<DataInstance[]> {
    return this.get<DataInstance[]>(`/game/${this.gameId}/data/${this.dataPackage}/${structTypeId}`);
  }

  public getDataInstancesAsResourceWithField(structTypeId: string, fieldId: string): Observable<Resource[]> {
    return this.get<Resource[]>(`/game/${this.gameId}/data/${this.dataPackage}/${structTypeId}/withField/${fieldId}`);
  }

  public getDataInstanceUidByFieldValue(structTypeId: string, fieldId: string, fieldValue: string): Observable<Resource> {
    return this.get<Resource>(`/game/${this.gameId}/data/${this.dataPackage}/${structTypeId}/${fieldId}/${fieldValue}`);
  }

  public getDataInstance(dataInstanceUid: string, structTypeId: string = '_'): Observable<DataInstance> {
    // Apparently 'structTypeId' is not required in this url... But if you want to pass it, go ahead
    return this.get<DataInstance>(`/game/${this.gameId}/data/${this.dataPackage}/${structTypeId}/${dataInstanceUid}`);
  }

  public getDataInstanceModified(dataInstanceUid: string): Observable<string> {
    return this.get<string>(`/game/${this.gameId}/data/${this.dataPackage}/${dataInstanceUid}/modified`);
  }

  public createDataInstance(dataInstance: DataInstance): Observable<DataInstance> {
    return this.post<DataInstance>(`/game/${this.gameId}/data/${this.dataPackage}/${dataInstance.dataType}`, dataInstance);
  }

  public updateDataInstance(structTypeId: string = '_', dataInstance: DataInstance): Observable<DataInstance> {
    return this.put<DataInstance>(`/game/${this.gameId}/data/${this.dataPackage}/${structTypeId}/${dataInstance.uid}`, dataInstance);
  }

  public deleteDataInstances(uids: string[], force = false): Observable<void> {
    return this.delete(`/game/${this.gameId}/data/${this.dataPackage}/data-instances`, {
      params: { dataInstanceUids: uids.join(','), force: String(force) },
    });
  }

  public duplicateDataInstances(dataInstances: DuplicateDataInstanceRequest): Observable<ConvertedDuplicatedDateInstances> {
    return this.post<ConvertedDuplicatedDateInstances>(`/game/${this.gameId}/data/${this.dataPackage}/duplicate`, dataInstances);
  }

  public getDataInstanceParent(dataInstanceUid: string): Observable<GetParentResponse> {
    return this.get<GetParentResponse>(`/game/${this.gameId}/search/${this.dataPackage}/datainstance/${dataInstanceUid}/parent`);
  }

  public getDataInstanceWithChildWithDatatypeAndFieldValue(
    parentDatatype: string,
    currentDataType: string,
    fieldValue: string,
  ): Observable<DataInstance> {
    return this.get<DataInstance>(
      `/game/${this.gameId}/search/${this.dataPackage}/parent-datatype/${parentDatatype}/current-datatype/${currentDataType}/fieldValue/${fieldValue}`,
    );
  }
}
